import { TextButton } from '@zillow/constellation-10';

import type { RenterPaymentMethodInterface } from '@renter-hub/models/Types';
import AvailablePaymentMethods from '../../../components/AvailablePaymentMethods';

interface Props {
  handleSelectPaymentMethodSelect: (data: RenterPaymentMethodInterface) => void;
  previouslySelectedPaymentMethod?: RenterPaymentMethodInterface;
  handleAddNewPaymentClick: () => void;
}

const SelectPaymentMethodsPage = ({
  handleSelectPaymentMethodSelect,
  previouslySelectedPaymentMethod,
  handleAddNewPaymentClick,
}: Props) => (
  <>
    <AvailablePaymentMethods
      onPaymentMethodClick={handleSelectPaymentMethodSelect}
      renderRadioView={true}
      selectedPaymentMethodId={previouslySelectedPaymentMethod?.id}
    />
    <TextButton onClick={handleAddNewPaymentClick}>Add new payment method</TextButton>
  </>
);

export default SelectPaymentMethodsPage;
